import type { FetchOptions, FetchRequest, MappedResponseType, ResponseType } from 'ofetch'
import type { ModuleOptions } from '../../types/module'
import { defu } from 'defu'
import { useRuntimeConfig } from 'nuxt/app'
import { CONFIG_KEY } from '../config'
import { $backendFetch } from './backend'

type ExtendedFetchOptions<R extends ResponseType = 'json'> = FetchOptions<R> & {
  extended?: {
    throwFatalError?: boolean
  }
}

export function $ssoFetch<T = any, R extends ResponseType = 'json'>(request: FetchRequest, options?: ExtendedFetchOptions<R>): Promise<MappedResponseType<R, T>> {
  return $backendFetch(request, defu(
    options,
    {
      baseURL: (useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).sso.apiUrl,
    },
  ))
}
